module.exports = __webpack_public_path__ + "img/banner1.fa916422.png";